import type from "../type/delivery.type"

export default [
  {
    title: type.delivery.title,
    field: type.delivery.value,
    options: type.delivery.value,
  },
  {
    title: type.pickup.title,
    field: type.pickup.value,
    options: type.pickup.value,
  },
  {
    title: type.deliveryTC.title,
    field: type.deliveryTC.value,
    options: type.deliveryTC.value,
  },
]